<template>
    <div class="text-lg">
        <slot />
    </div>
</template>

<script setup lang="ts">

</script>

<style scoped>

</style>